import React, { memo, useCallback } from 'react';

const Resizer = () => {
	const handleMouseMove = useCallback(({ pageX }) => {
		const minBreakPoint = 240;
		const maxBreakPoint = window.innerWidth - 300;

		if (pageX < minBreakPoint || pageX > maxBreakPoint) return;

		const positionInPercentages = (pageX / window.innerWidth) * 100;

		document.documentElement.style.setProperty('--custom-width', `${positionInPercentages}%`);
	}, []);

	const removeListeners = useCallback(() => {
		window.removeEventListener('mousemove', handleMouseMove);
		window.removeEventListener('mouseup', removeListeners);
	}, [handleMouseMove]);

	const addListeners = useCallback(() => {
		window.addEventListener('mousemove', handleMouseMove);
		window.addEventListener('mouseup', removeListeners);
	}, [handleMouseMove, removeListeners]);

	return <i className='custom-resizer fas fa-arrows-alt-h' onMouseDown={addListeners} />;
};

export default memo(Resizer);
